module.exports = __webpack_public_path__ + "img/minzhengju.9dd96287.png";